import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/Login";
import SignUp from "./pages/signup/SignUp";
import Dashboard from "./components/Dashboard";
import Projects from "./pages/projects";
import CreateProject from "./pages/projects/new";
import ProjectDetail from "./pages/projects/[id]";
import ProjectDiary from "./pages/projects/[id]/diary";
import ProjectFinancial from "./pages/projects/[id]/financial";
import ProjectUploads from "./pages/projects/[id]/uploads";
import EditProject from "./pages/projects/[id]/edit";
import InviteUser from "./pages/projects/[id]/invite";
import AcceptInvitation from "./pages/invitations/[token]";
import AcceptUserInvitation from "./pages/user-invitations/[token]";
import Users from "./pages/users";
import SmtpConfiguration from "./pages/smtp-configuration";
import ForcePasswordChange from "./pages/force-password-change";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AppLayout from "./components/AppLayout";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/invitations/:token" element={<AcceptInvitation />} />
      <Route path="/user-invitations/:token" element={<AcceptUserInvitation />} />
      <Route path="/force-password-change" element={
        <ProtectedRoute>
          <ForcePasswordChange />
        </ProtectedRoute>
      } />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/new" element={<CreateProject />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="projects/:id/diary" element={<ProjectDiary />} />
        <Route path="projects/:id/financial" element={<ProjectFinancial />} />
        <Route path="projects/:id/uploads" element={<ProjectUploads />} />
        <Route path="projects/:id/edit" element={<EditProject />} />
        <Route path="projects/:id/invite" element={<InviteUser />} />
        <Route path="users" element={
          <AdminRoute>
            <Users />
          </AdminRoute>
        } />
        <Route path="smtp-configuration" element={
          <AdminRoute>
            <SmtpConfiguration />
          </AdminRoute>
        } />
      </Route>
    </Routes>
  );
}